module.exports = "/images/favicon.png?2581676c3da07b2326ab8b719f4e1a70";